import React, { createContext, useState, useEffect } from 'react';
import NProgress from 'nprogress';
import { toast } from 'react-toastify';
import axios from 'axios';

export const AuthContext = createContext();

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));

  // Initialize auth state
  useEffect(() => {
    const initializeAuth = async () => {
      if (token) {
        try {
          NProgress.start();
          const res = await axios.get(`${API_URL}/user/profile`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUser(res.data);
        } catch (err) {
          console.error('Auth initialization error:', err);
          logout();
        } finally {
          NProgress.done();
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    initializeAuth();
  }, [token]);

  // Set auth token for all requests
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }, [token]);

  // Login function
  const login = async (phone, password) => {
    try {
      NProgress.start();
      const res = await axios.post(`${API_URL}/auth/login`, { phone, password });

      const { token: authToken, user: userData } = res.data;

      localStorage.setItem('token', authToken);
      setToken(authToken);
      setUser(userData);

      toast.success('Üstünlikli giriş edildi!');
      return true;
    } catch (err) {
      toast.error(err.response?.data?.message || 'Giriş edip bolmady');
      return false;
    } finally {
      NProgress.done();
    }
  };

  // Register function
  const register = async (userData) => {
    try {
      NProgress.start();
      const res = await axios.post(`${API_URL}/auth/register`, userData);

      const { token: authToken, user: newUser } = res.data;

      localStorage.setItem('token', authToken);
      setToken(authToken);
      setUser(newUser);

      toast.success('Üstünlikli hasap döredildi!');
      return true;
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registrasiýa edip bolmady');
      return false;
    } finally {
      NProgress.done();
    }
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    toast.info('Sistemadan çykyş edildi');
  };

  // Update profile function
  const updateProfile = async (profileData) => {
    try {
      NProgress.start();
      const res = await axios.put(`${API_URL}/user/profile`, profileData);
      setUser(res.data.user);
      toast.success('Profil üstünlikli täzelendi');
      return true;
    } catch (err) {
      toast.error(err.response?.data?.message || 'Profili täzeläp bolmady');
      return false;
    } finally {
      NProgress.done();
    }
  };


  // Change password function
  const changePassword = async (passwordData) => {
    try {
      NProgress.start();
      await axios.put(`${API_URL}/user/profile`, passwordData);
      toast.success('Açar söz üstünlikli üýtgedildi');

      // Hasapdan çykaryp, giriş sahypasyna ugrukdyr
      logout();
      window.location.href = '/'; // ýa-da react-router ulanýan bolsaňyz: navigate('/login');

      return true;
    } catch (err) {
      toast.error(err.response?.data?.message || 'Açar sözi üýtgedip bolmady');
      return false;
    } finally {
      NProgress.done();
    }
  };

  const value = {
    user,
    token,
    loading,
    login,
    register,
    logout,
    updateProfile,
    changePassword,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;